export enum LogActivityEnum {
    ADDED = 'Added',
    MODIFIED = 'Modified',
    DELETED = 'Deleted',
    LOGGED_IN = 'Logged In',
    LOGGED_OUT = 'Logged Out',
}
